import moment from 'moment';

const dateInPast = (firstDate: string, fromYesterday = false) =>
  moment(firstDate) < (fromYesterday ? moment().startOf('day') : moment());

export default dateInPast;
